import * as React from "react";
import { Typography } from "@material-ui/core";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { MenuItemAddOn, MenuItemOption } from "../../models";
import MenuItemOptionView from "./MenuItemOptionView";
import { getOptionId } from "../../helpers/menuItemHelper";

interface Props {
  onlyRead: boolean;
  menuItemAddOn: MenuItemAddOn;
  sessionAddOn: MenuItemAddOn;
  updateAddOn: (addOn: MenuItemAddOn) => void;
}

const MenuItemAddOnView: React.FC<Props> = ({ menuItemAddOn, sessionAddOn, updateAddOn, onlyRead}) => {

  const _checkAddOns = () => {
    const max = menuItemAddOn.max_size;
    if(max === 1 || max === 0){
      return true;
    }

    if(!!menuItemAddOn.global){
      return sessionAddOn.options.length < max;
    }else{
      //COUNT THE NUMBER OF DIFFERENT UNIQUE OPTIONS
      const optionIds = [...new Set(sessionAddOn.options.map(getOptionId))];
      return optionIds.length < max;
    }
  }

  const _addOption = (option: MenuItemOption) => {
    if (!_checkAddOns()) return;

    const max = menuItemAddOn.max_size;
    const optionId = getOptionId(option);

    if (max === 1) {
      // If only one option is allowed, replace the option unless it's the same as the first
      const firstOption = sessionAddOn.options[0];
      const newOptions =
        firstOption && getOptionId(firstOption) === optionId
          ? [...sessionAddOn.options, option]
          : [option];

      updateAddOn({ ...sessionAddOn, options: newOptions });
    } else {
      // Multiple options allowed
      updateAddOn({ ...sessionAddOn, options: [...sessionAddOn.options, option] });
    }
  };

  const _removeOption = (option: MenuItemOption) => {
    const optionId = getOptionId(option);

    // Find the first index of the option to remove
    const index = sessionAddOn.options.findIndex(o => getOptionId(o) === optionId);

    if (index === -1) return; // option not found

    // Remove only that one occurrence
    const newOptions = [...sessionAddOn.options];
    newOptions.splice(index, 1);

    // Update the addOn or remove if no options left
    if (newOptions.length <= 0) {
      updateAddOn({ ...sessionAddOn, options: [] });
    } else {
      updateAddOn({ ...sessionAddOn, options: newOptions });
    }
  };
  
  const _getQty = (item: MenuItemOption) => {
    let qty:number = 0;
    for(const opt of sessionAddOn.options){
      if(getOptionId(item) === getOptionId(opt)){
        qty ++;
      }
    }
    return qty;
  }

  const _buildSubtitle = () => {
    const maxSize = menuItemAddOn.max_size ?? 1;
    let subtitle = '';
    switch (true){
      case (maxSize < 1):
        subtitle += LocalizerHelper.localized('multiple_choice')
        break;
      case (maxSize == 1):
        subtitle += LocalizerHelper.localized('single_choice')
        break;
      case (maxSize > 1):
        subtitle += LocalizerHelper.localized('multiple_choice')
        break;
      default:
        break;
    }
    return <p>{subtitle} (<span style={{color:"#FE3436"}}>min {menuItemAddOn.min_size}</span>, max {menuItemAddOn.max_size})</p>;
  }

  if(menuItemAddOn.options.length <= 0) return null;

  return <div className="add-on">
    <Typography variant="h4" gutterBottom className="add-on-header" align="left">{LocalizerHelper.localized(menuItemAddOn, ['title'])}</Typography>
    <Typography variant="subtitle1" gutterBottom className="add-on-sub-header" align="left">{_buildSubtitle()}</Typography>
    {menuItemAddOn.options.map((option: MenuItemOption, index) => <MenuItemOptionView
      key={option.ref ?? "" + index}
      menuItemOption={option}
      quantity={_getQty(option)}
      addOption={_addOption}
      removeOption={_removeOption}
      onlyRead={onlyRead}
    />)}
  </div>
};

export default MenuItemAddOnView;
